"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.entityIndexTooManyRule = void 0;
exports.hasTooManyIndexes = hasTooManyIndexes;
const zod_1 = require("zod");
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
const ruleId = 'entity-index-too-many';
const ruleName = 'entity with too many indexes';
const ruleDescription = 'entities with number of indexes exceeding the threshold';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.EntityId.array().optional(),
    max: zod_1.z.number(),
}).strict().describe('EntityIndexTooManyConf');
exports.entityIndexTooManyRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.medium, max: 20 },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.entityRefFromId) || []);
        return (db.entities || [])
            .filter(e => hasTooManyIndexes(e, conf.max))
            .filter(e => !ignores.some(i => (0, databaseUtils_1.entityRefSame)(i, (0, databaseUtils_1.entityToRef)(e))))
            .map(e => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Entity ${(0, databaseUtils_1.entityToId)(e)} has too many indexes (${e.indexes?.length || 0}).`,
            entity: (0, databaseUtils_1.entityToRef)(e),
            extra: {
                count: e.indexes?.length || 0,
                indexes: (e.indexes || []).map(({ stats, extra, ...i }) => i)
            }
        }));
    }
};
function hasTooManyIndexes(entity, max) {
    return (entity.indexes?.length || 0) > max;
}
//# sourceMappingURL=entityIndexTooMany.js.map